import * as React from "react";

import logo from "../../../../assets/images/branding/logo-blue.svg";
import Layout from "../../../shared/components/layouts/FullPageLayout";

const ResetPasswordExpiredScreen = ({ onRequestNewPassword }) => {
  return (
    <Layout gridClassName="--narrow">
      <div className="logo --small _marginTop--large _marginBottom--normal">
        <img
          src={logo}
          alt="Logo"
        />
      </div>

      <div className="ds-card _solo">
        <section className="cardSection _eventPrompt">
          <i className="materialIcon --large -danger">link_off</i>
          <h1 className="subhead -danger">Expired Link</h1>
          <p className="copy">This password reset link has expired</p>
        </section>
        <a 
          data-testid='request-new-password-link'
          className="ds-btn --full"
          onClick={onRequestNewPassword}
        >
          Request New Reset Link
        </a>
      </div>
    </Layout>
  )
}

export default ResetPasswordExpiredScreen;



// WEBPACK FOOTER //
// ./src/features/user/components/resetPassword/ResetPasswordExpiredScreen.js